<template>
  <div
    class="col col-12 vert-align"
    :style="{ 'padding-left': isHorizontal ? '0' : '5px!important' }"
  >
    <div
      class="row f-row vert-align"
      style="font-size: 0.8rem!important; height: 1rem!important;"
    >
      <div
        v-show="showOHLC"
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ 'vertical-btn': !isHorizontal }"
        >
          <span class="button-label">Candles U/D</span>

          <span class="button-symbol">
            <div
              class="triangle-topleft-active"
              style="margin-right: 7px;"
            ></div>
          </span>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        :class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showMkt, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(12)"
        >
          <span>
            {{ fwdName }} {{ asset === "currencies" ? "rate" : "price" }}
          </span>

          <i
            class="fa fa-minus"
            style="color:var(--textactive)!important"
            v-if="showMkt"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showExpo, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(1)"
        >
          Reforcast {{ asset === "currencies" ? "rate" : "price" }}
          <i
            class="fa fa-minus"
            style="color:var(--dark-expo)"
            v-if="showExpo"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div v-if="!isAdvanced" :class="{ 'w-100': !isHorizontal }"></div>
      <div
        v-if="!isAdvanced"
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showBasisRatio, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(11)"
        >
          Commited {{ asset === "currencies" ? "rate" : "price" }}
          <i
            class="fa fa-minus"
            style="color:var(--hedge)"
            v-if="showBasisRatio"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        v-if="!isAdvanced"
        class="col"
        :style="
          isHorizontal
            ? { 'padding-left': '12px!important' }
            : { 'padding-right': '8px!important' }
        "
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <label
          :for="'showHedgeDetails'"
          class="toggle__button vert-align"
          :class="{ active: showFixedHedged }"
        >
          <input
            type="checkbox"
            v-on:click="onShow(16)"
            :id="'showHedgeDetails'"
          />

          <span :class="{ active: showFixedHedged }">
            Hedge details
          </span>

          <span class="toggle__switch"></span>
        </label>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showHedge, 'vertical-btn': !isHorizontal }"
          :style="
            isAdvanced && isHorizontal
              ? {}
              : { 'padding-left': '7px!important' }
          "
          v-on:click="onShow(2)"
        >
          {{ isAdvanced || !showFixedHedged ? "Hedged" : "Fixed" }}
          {{ asset === "currencies" ? "rate" : "price" }}
          <i class="fa fa-minus" style="color:var(--fwd)" v-if="showHedge"></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div
        v-if="!isAdvanced && showFixedHedged"
        :class="{ 'w-100': !isHorizontal }"
      ></div>
      <div
        v-if="!isAdvanced && showFixedHedged"
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showProtected, 'vertical-btn': !isHorizontal }"
          :style="
            isAdvanced && isHorizontal
              ? {}
              : { 'padding-left': '7px!important' }
          "
          v-on:click="onShow(15)"
        >
          Options {{ asset === "currencies" ? "rate" : "price" }}
          <i
            class="fa fa-minus"
            style="color:var(--net_2)"
            v-if="showProtected"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showNet, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(3)"
        >
          Net {{ asset === "currencies" ? "rate" : "price" }}
          <i class="fa fa-minus" style="color:var(--net)" v-if="showNet"></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div v-if="isAdvanced" :class="{ 'w-100': !isHorizontal }"></div>
      <div
        v-if="isAdvanced"
        class="col"
        :style="
          isHorizontal
            ? {
                'padding-left': '5px!important',
                'padding-right': '8px!important',
              }
            : { 'padding-right': '8px!important' }
        "
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <label
          :for="'showHedgeDetailsRates'"
          class="toggle__button vert-align"
          :class="{ active: showDerivatives }"
        >
          <input
            type="checkbox"
            v-on:click="onShowDerivatives"
            :id="'showHedgeDetailsRates'"
          />

          <span :class="{ active: showDerivatives }">
            All derivatives
          </span>

          <span class="toggle__switch"></span>
        </label>
      </div>

      <div v-if="showFixedHedged" :class="{ 'w-100': !isHorizontal }"></div>
      <!-- <div class="col col-7" v-show="!showDerivatives && isHorizontal"></div> -->
      <div
        v-show="showDerivatives"
        class="col"
        :style="
          isHorizontal
            ? {
                'padding-left': '5px!important',
                'padding-right': '8px!important',
              }
            : {
                'padding-left': '7px!important',
                'padding-right': '8px!important',
              }
        "
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <label
          :for="'showHedgeAverages'"
          class="toggle__button vert-align"
          :class="{ active: showAve }"
        >
          <input
            type="checkbox"
            v-on:click="onShow(0)"
            :id="'showHedgeAverages'"
          />

          <span :class="{ active: showAve }">
            Average
          </span>

          <span class="toggle__switch"></span>
        </label>
      </div>
      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          style="padding-left: 7px!important;"
          :class="{ active: showLFwd, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(5)"
        >
          <span class="button-label"><i class="fa fa-plus"></i>Fwd/Fut</span>

          <span class="button-symbol">
            <img
              v-if="!showAve"
              :style="!isHorizontal && { marginRight: '4px' }"
              :src="lFwd"
              height="16"
              alt=""
            />
            <template v-else>
              <i
                class="fa fa-minus"
                style="color:var(--fwd);"
                v-if="showLFwd"
              ></i>
              <i
                class="fa fa-minus"
                style="color:var(--textinactive);"
                v-else
              ></i>
            </template>
          </span>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          style="padding-left: 7px!important;"
          :class="{ active: showSFwd, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(6)"
        >
          <span class="button-label"><i class="fa fa-minus"></i>Fwd/Fut</span>

          <span class="button-symbol">
            <img
              v-if="!showAve"
              :style="!isHorizontal && { marginRight: '4px' }"
              :src="sFwd"
              height="16"
              alt=""
            />

            <template v-else>
              <i
                class="fa fa-minus"
                style="color:var(--dark-fwd);"
                v-if="showSFwd"
              ></i>
              <i
                class="fa fa-minus"
                style="color:var(--textinactive);"
                v-else
              ></i>
            </template>
          </span>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <div class="img-v-align w-100">
          <button
            class="btn detailView"
            style="padding-left: 7px!important;"
            :class="{ active: showLCall, 'vertical-btn': !isHorizontal }"
            v-on:click="onShow(7)"
          >
            <span class="button-label"><i class="fa fa-plus"></i>Call</span>

            <span class="button-symbol">
              <img
                v-if="!showAve"
                :style="!isHorizontal && { marginRight: '4px' }"
                :src="lCall"
                height="16"
                alt=""
              />

              <template v-else>
                <i
                  class="fa fa-minus"
                  style="color:var(--call);"
                  v-if="showLCall"
                ></i>
                <i
                  class="fa fa-minus"
                  style="color:var(--textinactive);"
                  v-else
                ></i>
              </template>
            </span>
          </button>
        </div>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <div class="img-v-align w-100">
          <button
            class="btn detailView"
            style="padding-left: 7px!important;"
            :class="{ active: showSCall, 'vertical-btn': !isHorizontal }"
            v-on:click="onShow(8)"
          >
            <span class="button-label"><i class="fa fa-minus"></i>Call</span>

            <span class="button-symbol">
              <img
                v-if="!showAve"
                :style="!isHorizontal && { marginRight: '4px' }"
                :src="sCall"
                height="16"
                alt=""
              />

              <template v-else>
                <i
                  class="fa fa-minus"
                  style="color:var(--dark-call);"
                  v-if="showSCall"
                ></i>
                <i
                  class="fa fa-minus"
                  style="color:var(--textinactive);"
                  v-else
                ></i>
              </template>
            </span>
          </button>
        </div>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <div class="img-v-align w-100">
          <button
            class="btn detailView"
            style="padding-left: 7px!important;"
            :class="{ active: showLPut, 'vertical-btn': !isHorizontal }"
            v-on:click="onShow(9)"
          >
            <span class="button-label"><i class="fa fa-plus"></i>Put</span>

            <span class="button-symbol">
              <img
                v-if="!showAve"
                :style="!isHorizontal && { marginRight: '4px' }"
                :src="lPut"
                height="16"
                alt=""
              />

              <template v-else>
                <i
                  class="fa fa-minus"
                  style="color:var(--put);"
                  v-if="showLPut"
                ></i>
                <i
                  class="fa fa-minus"
                  style="color:var(--textinactive);"
                  v-else
                ></i>
              </template>
            </span>
          </button>
        </div>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="showDerivatives"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <div class="img-v-align w-100">
          <button
            class="btn detailView"
            style="padding-left: 7px!important;"
            :class="{ active: showSPut, 'vertical-btn': !isHorizontal }"
            v-on:click="onShow(10)"
          >
            <span class="button-label"><i class="fa fa-minus"></i>Put</span>

            <span class="button-symbol">
              <img
                v-if="!showAve"
                :style="!isHorizontal && { marginRight: '4px' }"
                :src="sPut"
                height="16"
                alt=""
              />

              <template v-else>
                <i
                  class="fa fa-minus"
                  style="color:var(--dark-put);"
                  v-if="showSPut"
                ></i>
                <i
                  class="fa fa-minus"
                  style="color:var(--textinactive);"
                  v-else
                ></i>
              </template>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatesChartSelectors",
  props: {
    asset: { required: false, default: "currencies" },
    fwdName: { required: true },
    isAdvanced: { required: false, type: Boolean, default: true },
    isHorizontal: { required: false, type: Boolean, default: true },
    lCall: { required: true },
    lFwd: { required: true },
    lPut: { required: true },
    sCall: { required: true },
    sFwd: { required: true },
    showAve: { required: true },
    showDerivatives: { required: true },
    showExpo: { required: true },
    showBasisRatio: { required: false, type: Boolean, default: false },
    showFixedHedged: { required: false, type: Boolean, default: false },
    showHedge: { required: true },
    showProtected: { required: false, type: Boolean, default: false },
    showLCall: { required: true },
    showLFwd: { required: true },
    showLPut: { required: true },
    showMkt: { required: true },
    showNet: { required: true },
    showOHLC: { required: true },
    showSCall: { required: true },
    showSFwd: { required: true },
    showSPut: { required: true },
    sPut: { required: true },
  },
  data() {
    return {
      // translateSignal=[]
    };
  },
  methods: {
    onShow(val) {
      this.$emit("eventOnShow", val);
    },
    onShowDerivatives() {
      this.$emit("eventOnShowDerivatives");
    },
  },
};
</script>

<style scoped>
.toggle__button {
  vertical-align: middle !important;
  user-select: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}

.toggle__button .toggle__switch {
  display: inline-block;
  height: 0.8rem;
  border-radius: 6px;
  width: 1.1rem;
  background: var(--graylightbackground);
  /* box-shadow: inset 0 0 1px var(--graylightbackground); */
  position: relative;
  margin: 0;
  top: 0;
  left: 3px;
  transition: all 0.25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 0.65rem;
  width: 0.65rem;
  border-radius: 50%;
  left: 1px;
  top: 1px;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}

.toggle__button .toggle__switch::after {
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 1px white; */
}

.toggle__button .toggle__switch::before {
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1); */
  opacity: 0;
}

.active .toggle__switch {
  background: var(--dark-expo);
  /* box-shadow: inset 0 0 1px var(--graylightbackground); */
}

/* .active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(2px);
} */

.active .toggle__switch::after {
  left: 5px;
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 1px var(--expo); */
}
</style>
